'use strict';

module.exports = require('../src/traces/bar');
